import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { StrapiMediaDTO } from "@lib/strapi/dtos/core/media.dto";
import {
  StrapiLinkDTO,
  LinkDTO,
} from "@lib/strapi/dtos/components/shared/link.dto";
import { ImageProps } from "@lib/image";

export interface StrapiHeroSectionDTO extends StrapiDynamicZoneComponentDTO {
  style: "Homepage" | "Page" | "Compact";
  heading: string;
  subheading: string;
  image: StrapiMediaDTO;
  links: StrapiLinkDTO[];
  showPhoneCta: boolean;
}

export class HeroSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  style: "Homepage" | "Page" | "Compact";
  heading: string;
  subheading: string;
  image: ImageProps;
  links: LinkDTO[];
  showPhoneCta: boolean;
}
